import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  commonPostPutFormData,
  fetchApiData,
} from "../../../redux/reducers/commonApiSlice";
import { CALL_DETAILS, CONVERTED_AUDIO } from "../../../data/ApiEndpoints";
import { formatDateTime } from "../../common-data/Converts";
import { toast } from "react-toastify";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import PaginationModified from "../../../data/PaginationModified";
import { BiBanIcon } from "../../../images/icons/icons";

const CallDetail = ({ userInfoData, rowData, filterType }) => {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.common);

  const [isPage, setIsPage] = useState(0);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    filter_type: filterType,
    mobile: rowData?.mobile,
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniAllDatas = {
    pagination: [],
    allCalls: [],
    isAudioGenerated: false,
    audioReadyLink: "",
  };
  const [allDatas, setAllDatas] = useState(iniAllDatas);
  const iniClickValues = {
    isModOpen: false,
    rowData: "",
    cardName: "",
  };
  const [clickValues, setClickValues] = useState(iniClickValues);

  function onCloseModal() {
    setClickValues(iniClickValues);
    setAllDatas((prevs) => ({
      ...prevs,
      isAudioGenerated: false,
      audioReadyLink: "",
    }));
  }

  function getCallDetails(filters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: CALL_DETAILS,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const handleConvertAudio = async (requestBody) => {
    const method = "POST";
    const endpoint = CONVERTED_AUDIO;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody, token })
      );

      if (result?.payload?.code === 200 && result?.payload?.url) {
        setAllDatas((prevs) => ({
          ...prevs,
          isAudioGenerated: true,
          audioReadyLink: result.payload.url,
        }));
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
        setAllDatas((prevs) => ({
          ...prevs,
          isAudioGenerated: false,
          audioReadyLink: "",
        }));
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  function getPagination() {
    try {
      const pagination = allDatas.pagination ? allDatas.pagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (rowData) {
      setFilters((prevs) => ({
        ...prevs,
        filter_type: filterType,
        mobile: rowData?.mobile,
      }));
    }
  }, []);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
    }));
  }, [isPage]);

  useEffect(() => {
    if (filters.filter_type) {
      getCallDetails(filters);
    }
  }, [filters]);

  useEffect(() => {
    if (data?.status && data?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        pagination: data?.pagination,
        allCalls: data.data,
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        pagination: [],
        allCalls: [],
      }));
    }
  }, [data]);

  useEffect(() => {
    if (clickValues.cardName === "converted_audio") {
      const formData = new FormData();
      // formData.append("panel_type", clickValues.rowData?.panel_type);
      formData.append("panel_type", "panel_1");
      formData.append("recording_link", clickValues.rowData?._fn);
      handleConvertAudio(formData);
    }
  }, [clickValues]);

  const tbColumns = [
    {
      dataField: "status",
      text: "Call Status",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "_cl",
      text: "Client Number",
      formatter: (_, row) => {
        return <span className="tb-data">{row?._cl || "NA"}</span>;
      },
    },
    {
      dataField: "date_added",
      text: "Call Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "_drm",
      text: "Call Duration (Minutes)",
      formatter: (_, row) => {
        return <span className="tb-data">{row?._drm || "-"}</span>;
      },
    },
    // {
    //   dataField: "_se",
    //   text: "Region",
    //   formatter: (_, row) => {
    //     return <span className="tb-data">{row?._se || "NA"}</span>;
    //   },
    // },
    {
      dataField: "_fn",
      text: "Recording Link",
      formatter: (_, row) => {
        return (
          <>
            {row?._fn ? (
              <>
                {/* <button
                  type="button"
                  className={`actionBtn icon`}
                  style={{ width: "100%" }}
                  onClick={() => {
                    setClickValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      rowData: row,
                      cardName: "converted_audio",
                    }));
                  }}
                >
                  {postPutLoadingFormData ? <Loader /> : <DownloadIcon />}
                </button> */}
                <audio controls>
                  <source src={row._fn} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
                {/* {allDatas.isAudioGenerated && allDatas.audioReadyLink ? (
                  <audio controls>
                    <source src={allDatas.audioReadyLink} type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                ) : (
                  <button
                    type="button"
                    className={`actionBtn icon`}
                    onClick={() => {
                      setClickValues((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        rowData: row,
                        cardName: "convert_audio",
                      }));
                    }}
                  >
                    {postPutLoadingFormData ? (
                      <Loader />
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#5356FF"
                        className="bi bi-cloud-arrow-up-fill"
                        viewBox="0 0 16 16"
                        style={{
                          color: "#5356FF",
                          width: "35px",
                          height: "35px",
                        }}
                      >
                        <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 5.146a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0z" />
                      </svg>
                    )}
                  </button>
                )} */}
              </>
            ) : (
              <span className="tb-data">
                <BiBanIcon />
              </span>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Audio Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer miniModal`}>
          <ModalHeadAndClose
            title={`${clickValues.cardName?.replace(/_/, " ")}`}
            onClose={onCloseModal}
          />

          {clickValues.cardName === "converted_audio" ? (
            <div className="mod-audio-player">
              {allDatas.isAudioGenerated && allDatas.audioReadyLink ? (
                <audio controls>
                  <source src={allDatas.audioReadyLink} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-ban"
                  viewBox="0 0 16 16"
                  style={{
                    color: "gray",
                    width: "35px",
                    height: "35px",
                    cursor: "not-allowed",
                  }}
                >
                  <path d="M15 8a6.97 6.97 0 0 0-1.71-4.584l-9.874 9.875A7 7 0 0 0 15 8M2.71 12.584l9.874-9.875a7 7 0 0 0-9.874 9.874ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0" />
                </svg>
              )}
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allCalls}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        )}
      </div>

      <div className="lead-logs-card-container call-details only-mobile">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <div className="all-leads-log mt30">
            {allDatas.allCalls?.length > 0 &&
              allDatas.allCalls.map((lead, index) => {
                return (
                  <div className="log-card" key={index}>
                    <div className="all-info">
                      <div className="log-card-top">
                        <h3 className="lead-name">{lead?.status || "NA"}</h3>

                        <span className={`lead-type button my-3`}>
                          {lead?._fn ? (
                            <>
                              <audio controls>
                                <source src={lead._fn} type="audio/mpeg" />
                                Your browser does not support the audio element.
                              </audio>

                              {/* <button
                                type="button"
                                className={`actionBtn icon`}
                                onClick={() => {
                                  setClickValues((prevs) => ({
                                    ...prevs,
                                    isModOpen: true,
                                    rowData: lead,
                                    cardName: "converted_audio",
                                  }));
                                }}
                              >
                                {postPutLoadingFormData ? (
                                  <Loader />
                                ) : (
                                  <DownloadIcon />
                                )}
                              </button> */}
                            </>
                          ) : (
                            <BiBanIcon />
                          )}
                        </span>
                      </div>

                      <div className="card-other-info">
                        <span className="value semi-bold">
                          {lead?._cl || "NA"}
                        </span>
                        <span className="value email semi-bold">
                          {lead?.date_added
                            ? formatDateTime(lead.date_added)
                            : "-"}
                          {/* {lead?._ts ? formattedLongDate(lead._ts) : "-"} */}
                        </span>
                        <span className="value semi-bold">
                          {lead?._drm || 0} Minutes
                        </span>
                        <span className="value semi-bold">
                          {lead?._se || "NA"}
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}

            <div className="lead-logs-card-pagination">
              <PaginationModified
                isPage={isPage}
                onChangePage={setIsPage}
                pagination={getPagination()}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CallDetail;
